// extracted by mini-css-extract-plugin
export var childrenContainer = "_by-0";
export var virtualScrollArea = "_by-1";